import { render } from "./CreationTabs.vue?vue&type=template&id=006c7307&scoped=true"
import script from "./CreationTabs.vue?vue&type=script&lang=js"
export * from "./CreationTabs.vue?vue&type=script&lang=js"

import "./CreationTabs.vue?vue&type=style&index=0&id=006c7307&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-006c7307"]])

export default __exports__